export default __webpack_public_path__ + "static/media/satvikk.71543d9e.jpg";